import { z } from "zod"

export const LocationDtoSchema = z
  .object({
    longitude: z.number(),
    latitude: z.number(),
  })
  .meta({ id: "LocationDtoSchema" })

export type LocationDto = z.infer<typeof LocationDtoSchema>
